import { sharesName } from '@/lib/redeem'

/** A row's name, with its slug after it in muted text when another row has the
 *  same name. Pass the app list the page already has. */
export function AppName({
  app,
  apps,
}: {
  app: { name: string; slug: string }
  apps: readonly { name: string; slug: string }[]
}) {
  return (
    <>
      {app.name}
      {sharesName(app, apps) && <span className="font-normal text-muted-foreground"> · {app.slug}</span>}
    </>
  )
}
